import { CfsApi, MasterNameApi } from '@/api';
import { TabLayoutContextProvider } from '@/layouts/TabLayout';
import { MasterNamesContextProvider } from '@/layouts/TabLayout/MasterNames';
import { MasterAddNameDetails } from '@/layouts/TabLayout/MasterNames/components/MasterAddNameDetails';
import { ICFSInvolvement, MasterNameInvolvement } from '@/models';

interface AddPersonPanelProps {
  onClose: () => void;
  cfsId: string;
}

const AddPersonPanel = ({ onClose, cfsId }: AddPersonPanelProps) => {
  return (
    <TabLayoutContextProvider>
      <MasterNamesContextProvider
        nextRoutes={[]}
        handleSubmit={() => {}}
        updateMasterName={(nameId: string, data) =>
          MasterNameApi.updateMasterName({ _id: nameId, ...data })
        }
        getMasterName={(nameId: string) => MasterNameApi.getMasterName(nameId)}
        involvementOptions={MasterNameInvolvement}
        addLinkedName={(
          nameId: string,
          data?: { relationship: ICFSInvolvement },
        ) =>
          CfsApi.addCfsMasterName(
            cfsId,
            nameId,
            data as { relationship: ICFSInvolvement },
          )
        }
      >
        <MasterAddNameDetails onGoBack={onClose} />
      </MasterNamesContextProvider>
    </TabLayoutContextProvider>
  );
};

export default AddPersonPanel;
